import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'ui-app-loader',
  templateUrl: './app-loader.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppLoaderComponent {
}
